<script setup lang="ts">

import { DsIcon } from '@demvsystems/design-components';
import { ElTooltip } from 'element-plus';
</script>

<template>
  <ElTooltip
    content="Ausgefüllt vom KI Assistenten"
    placement="top-end"
  >
    <DsIcon
      name="sparkles"
      variant="regular"
      size="sm"
      class="text-blue-500 cursor-help"
    />
  </ElTooltip>
</template>
